import { restService } from "../rest.js";
const restServiceInstance = new restService();
function kpiOcupacion() {
  this.allStock = [];
  this.allVehicles = [];
  this.vehicleCounter = {};
  this.vehiclesInOperationUnit = [];
  this.vehicles = {};
  this.getVehiclesInOperationUnit = function(sucursal) {
    this.allStock.forEach(vehicle => {
      if (
        vehicle &&
        vehicle.product_id &&
        vehicle.almacen_id &&
        (vehicle.almacen_id[1] == sucursal || sucursal == "all")
      ) {
        this.vehiclesInOperationUnit.push(vehicle);
        if (!this.vehicleCounter[vehicle.estado]) {
          this.vehicleCounter[vehicle.estado] = 0;
        }
        this.vehicleCounter[vehicle.estado]++;
      }
    });
  };
  this.getFamilias = function(familiasIdsObj) {
    const promise = new Promise((resolve, reject) => {
      //var familias = [];
      var familias = {};
      restServiceInstance
        .getProducts()
        .then(productos => {
          productos.forEach(producto => {
            if (familiasIdsObj[producto.id]) {
              // var ocupacionFamilia = familiasIdsObj[producto.id];
              // ocupacionFamilia.name = producto.name;
              // ocupacionFamilia.id = producto.id;
              // familias.push(ocupacionFamilia);
              familias[producto.name]=familiasIdsObj[producto.id];
            }
          });

          resolve(familias);
        })
        .catch(error => {
          reject(error);
        });
    });
    return promise;
  };
  this.getVehicles = function(sucursal, axios) {
    const kpiOcupacion = this;
    this.allStock = [];
    this.allVehicles = [];
    this.vehicleCounter = {};
    this.vehiclesInOperationUnit = [];
    this.vehicles = {};
    const promise = new Promise((resolve, reject) => {
      if (kpiOcupacion.allVehicles.length > 0) {
        kpiOcupacion.getVehiclesInOperationUnit(sucursal);
        resolve(kpiOcupacion.vehiclesInOperationUnit);
      } else {
        restServiceInstance
          .getStockLot()
          .then(stock => {
            kpiOcupacion.allStock = stock;
            kpiOcupacion.getVehiclesInOperationUnit(sucursal);
            resolve(kpiOcupacion.vehiclesInOperationUnit);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
    return promise;
  };
}
export { kpiOcupacion };
